import React, { Fragment, useEffect } from 'react'
import { boolVal, strVal } from '../../../../modules/Utils'
import Status from '../../../../elements/Status'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import StatusCell from '../../../../elements/Table/Cells/StatusCell'
import useTitle from '../../../../elements/Hooks/useTitle'
import DateCell from '../../../../elements/Table/Cells/DateCell'
import FileCell from '../../../../elements/Table/Cells/FileCell'
import { Link } from 'react-router-dom'

const CheckboxTable = checkboxHOC(CustomTable)
const columns = [
  {
    Header: 'Receipt',
    accessor: 'code',
    Cell: ({ value, original }) => (
      <Link to={`/clients/receipts/${original._key}/view`} style={{ marginLeft: '10px' }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Transaction Date',
    accessor: 'transaction.date',
    Cell: DateCell,
  },
  {
    Header: 'Company',
    accessor: 'company.fn',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Client',
    accessor: 'client.fn',
    width: 300,
  },
  {
    Header: 'Contract',
    accessor: 'contract.code',
  },
  {
    Header: 'Currency',
    accessor: 'currency',
    Cell: ({ value, original }) => value || strVal(original, 'transaction.currency'),
  },
  {
    Header: 'Receipt Total',
    accessor: 'receiptsTotal',
    style: { textAlign: 'right' },
    Cell: ({ value, original }) => (
      <MoneyCell value={original.receiptType === 'deposit' ? original.allocated : value}/>
    ),
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: StatusCell,
  },
  {
    Header: 'File',
    accessor: 'file',
    Cell: FileCell,
  },
]

function List (props) {
  const {
    fetching,
    company,
    show,
    onChangeCompany,
    fetch,
    list,
    selection,
    fetchingEmailTemplate,
    showEmail,
    isSelected,
    toggleSelection,
  } = props
  useEffect(() => {
    fetch()
    return () => {}
  }, [])
  const checkboxProps = {
    selectType: 'checkbox',
    isSelected,
    toggleSelection,
  }
  useTitle('Receipts')
  return (
    <Fragment>
      <CheckboxTable
        fetch={fetch}
        isFilterable={true}
        ExtraButtons={() => (
          <Fragment>
            <Button
              size={'small'}
              loading={fetchingEmailTemplate}
              onClick={showEmail}
              disabled={selection.length === 0}
              style={{ float: 'left' }}>
              Email Issuance
            </Button>
          </Fragment>
        )}
        ExtraOptionsButtons={() =>
          boolVal(show, 'companyFilter') && (
            <OrganisationsSelect
              onChange={onChangeCompany}
              value={company}
              size={'small'}
              style={{ width: '450px', paddingRight: 20 }}
            />
          )
        }
        columns={columns.map(c => ({
          style: { textAlign: 'center' },
          ...c,
        }))}
        data={list}
        loading={fetching}
        defaultPageSize={20}
        {...checkboxProps}
      />
    </Fragment>
  )
}

export default List
